import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ProfileCompletion } from '../../entities/insights/spotlight-directories/profile-completion.model';
import { SpotlightDirectoriesFilters } from '../../entities/insights/spotlight-directories/spotlight-directories.model';
import { DashboardApiService } from '../db-api.service';

@Injectable({
  providedIn: 'root',
})
export class SpotlightDirectoriesApiService extends DashboardApiService {
  getProfileCompletion(
    spotlightDirectoryId: number,
    params: SpotlightDirectoriesFilters,
  ): Observable<ProfileCompletion> {
    const url = `v1/dashboard/analytics/spotlight_directories/${spotlightDirectoryId}/profile_completion`;

    return this._get(this._buildSearchParams(params, url)).pipe(
      map((res) => this._handleResponse(res)),
      catchError((res) => this._handleError(res)),
    );
  }

  private _buildSearchParams(params: object, url: string) {
    const searchParams = new URLSearchParams();

    Object.entries(params)
      .filter(([, value]) => !!value)
      .forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach((item) => {
            searchParams.append(`${key}[]`, item);
          });
        } else {
          searchParams.set(key, value.toString());
        }
      });

    return !!searchParams.toString() ? `${url}?${searchParams.toString()}` : url;
  }
}
